/*------------------------------------------------
// File Name:PDM_DR_UserInfo.js
// File Description:PDM_DR_UserInfo store方法
// Author:zxl
// Create Time:2023/07/18 17:33:39
//------------------------------------------------*/

import {
    GetPDM_DR_UserInfoList,
    GetPDM_DR_UserInfoListByPage,
    GetPDM_DR_UserInfoEntity,
    CreatePDM_DR_UserInfoEntity,
    UpdatePDM_DR_UserInfoEntity,
    DeletePDM_DR_UserInfoEntity,
} from '@/api/pdm/dr/drUserinfo'

import msg from '@/config/notify'
import dlg from '@/config/dialog'
//import { toRaw } from "vue";

export const PdmDrUserinfo = {
    namespaced: true,
    state: {
        PdmDrUserinfoList: [],
        PdmDrUserinfoListLoading: false,
        PdmDrUserinfoEntity: null,
        PdmDrUserinfoShowDlg: false,
    },
    mutations: {
        setPdmDrUserinfoList(state, dataList) {
            state.PdmDrUserinfoList = [...dataList]
        },
        setPdmDrUserinfoListLoading(state, visible) {
            state.PdmDrUserinfoListLoading = visible
        },
        setPdmDrUserinfoShowDlg(state, visible) {
            state.PdmDrUserinfoShowDlg = visible
        },
        setPdmDrUserinfoEntity(state, entity) {
            state.PdmDrUserinfoEntity = entity
        },
    },
    actions: {
        //创建对象
        actCreatePdmDrUserinfo({ commit }, parm) {
            return new Promise((resolve, reject) => {
                CreatePDM_DR_UserInfoEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmDrUserinfoEntity', res.Data)
                        commit('setPdmDrUserinfoShowDlg', true)
                         //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        reject(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载对象
        actGetPdmDrUserinfoEntity({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmDrUserinfoListLoading', true)
                GetPDM_DR_UserInfoEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmDrUserinfoEntity', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmDrUserinfoListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //加载列表
        actGetPdmDrUserinfoList({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmDrUserinfoListLoading', true)
                GetPDM_DR_UserInfoList(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmDrUserinfoList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        //msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmDrUserinfoListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //分页加载列表
        actGetPdmDrUserinfoListByPage({ commit }, parm) {
            return new Promise((resolve) => {
                commit('setPdmDrUserinfoListLoading', true)
                GetPDM_DR_UserInfoListByPage(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmDrUserinfoList', res.Data)
                        //msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                       // msg.error(res.Message)
                    }
                }).finally(() => {
                    commit('setPdmDrUserinfoListLoading', false)
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //保存信息
        actUpdatePdmDrUserinfo({ commit }, parm) {
            return new Promise((resolve) => {
                UpdatePDM_DR_UserInfoEntity(parm).then(res => {
                    if (res.Code == 0) {
                        commit('setPdmDrUserinfoShowDlg', false)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_DR_UserInfo
        actEditPdmDrUserinfoData({ commit }, entity) {
            return new Promise((resolve) => {
                let parm = {                    
                    PdmDrUserinfoID : entity.PdmDrUserinfoID
                }
                GetPDM_DR_UserInfoEntity(parm).then(res => {
                    if (res.Code == 0) {
                        // var info = {}
                        // Object.assign(info,state.getTableNameL3(TableName.Name)%>Entity)
                        // Object.assign(info,res.Data)
                        // commit('getTableNameL3(TableName.Name)%>Entity', info)
                        commit('setPdmDrUserinfoEntity', res.Data)
                        commit('setPdmDrUserinfoShowDlg', true)
                        msg.success(res.Message)
                        resolve(res)
                    } else {
                        dlg.alert(res.Message)
                        resolve(res)
                    }
                })
            }).catch(err => {
                console.log(err)
            })
        },
        //编辑PDM_DR_UserInfo ,传对象过来
        actEditPdmDrUserinfo({ commit }, entity) {
            return new Promise(() => {
                commit('setPdmDrUserinfoEntity', entity)
                commit('setPdmDrUserinfoShowDlg', true)
            }).catch(err => {
                console.log(err)
            })
        },
        //删除PDM_DR_UserInfo
        actDeletePdmDrUserinfo({ commit }, e) {
            return new Promise((resolve) => {
                dlg.confirm("是否确定要删除当前？").onOk(() => {
                    DeletePDM_DR_UserInfoEntity(e).then(res => {
                        if (res.Code == 0) {
                            commit('setPdmDrUserinfoShowDlg', false)
                           
                            msg.success("删除成功。")
                            resolve(res)
                        } else {
                            dlg.alert("删除失败，原因:" + res.Message)
                            //msg.success("删除失败，原因:" + res.Message)
                            resolve(res)
                        }
                    })
                })
            }).catch(err => {
                console.log(err)
            })
        }
    }
}


